/// <reference path="../../typings/index.d.ts" />


module monitoringApp.controller {
    class SuiteRunController {
        private suiteRunId: number;
        private endedAt: string;
        private pollId: number;
        private pollInterval: number = 2000;
        private statusFilter: string = 'all';
        private suiteRunResult: monitoringApp.entities.IRunSuiteResult;

        private mainChartData: Array<Number> = [0,0,0];
        private mainChartColors: string[] = ["#4CAF50", "#f7464a", "#eeeeee"];
        

        constructor(private dataAccessService: monitoringApp.common.DataAccessService, private $scope: ng.IScope) {
            this.watch();
        }

        private getSuiteRun(): void {
            var resource = this.dataAccessService.getSuiteRunResult(this.suiteRunId);
            resource.get((data: monitoringApp.entities.IRunSuiteResult) => {
                console.log(data);
                this.suiteRunResult = data;   
                this.mainChartData =  [
                    this.suiteRunResult.passedTask,
                    this.suiteRunResult.failedTask,
                    this.suiteRunResult.taskCount - this.suiteRunResult.failedTask - this.suiteRunResult.passedTask
                ]           
            });
        }

        private watch(): void {
            this.$scope.$watch(() => this.suiteRunId, (newVal) => {
                clearInterval(this.pollId);
                this.poll()
            });
        }

    

        private poll(): void {
            if (typeof this.suiteRunId !== 'undefined') {
                this.getSuiteRun();
                if (!this.endedAt) {
                    this.pollId = setInterval(() => this.getSuiteRun(), 2000);
                }
            }
        }


        static $inject = ["dataAccessService", "$scope"];
    }

    angular.module("ultimateMonitoringApp").controller("suiteRunController", SuiteRunController);
}

